import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import urlsForHideConnectButton from '@r1-frontend/entities/Layout/Header/urlsForHideConnectButton';
import { selectHasAuthorization } from '@r1-frontend/entities/stores/auth/selectors/selectAccessToken';

/**
 * Хук для определения отображения номера телефона и кнопки подключения в хедере сайта
 */
export const useLeadGeneration = () => {
    const hasAuthorization = useSelector(selectHasAuthorization);
    const { pathname } = useRouter();

    return useMemo(() => {
        // в АЗ нет кнопки подключения, номер телефона отображаем всегда
        if (hasAuthorization) {
            return {
                showPhone: true,
                showButton: false,
            };
        }

        // на страницах, связанных с ПП, всегда скрываем кнопку подключения
        if (urlsForHideConnectButton.includes(pathname)) {
            return {
                showPhone: true,
                showButton: false,
            };
        }

        // отображаем кнопку подключения и номер телефона на всех остальных страницах
        return {
            showPhone: true,
            showButton: true,
        };
    }, [hasAuthorization, pathname]);
};
